import { useEffect, useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { Section } from "../components/Section";
import { Seo } from "../components/Seo";
import { SocialShare } from "../components/SocialShare";
import { EventItem, getEvents } from "../data/events";

function calendarDateLabel(event: EventItem) {
  const source = event.date || event.startIso || "";
  const mmddyyyy = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(source);
  const isoDate = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(source);
  const parsed = mmddyyyy
    ? new Date(Number(mmddyyyy[3]), Number(mmddyyyy[1]) - 1, Number(mmddyyyy[2]), 12)
    : isoDate
      ? new Date(Number(isoDate[1]), Number(isoDate[2]) - 1, Number(isoDate[3]), 12)
      : new Date(source);
  if (!Number.isFinite(parsed.getTime())) return "Date TBA";
  return parsed.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function Calendar() {
  const [events, setEvents] = useState<EventItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getEvents({ useFallback: false })
      .then(setEvents)
      .catch((err) => {
        console.warn("[public-web] Calendar page load failed", err);
        setError("Calendar events could not be loaded right now.");
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Seo title="Calendar" description="Upcoming events and school calendar information for Zion Classical Academy families." path="/calendar" />
      <PageHeader eyebrow="Calendar" title="Upcoming events">
        School calendar items can later be published from Firebase and surfaced here for families and prospective parents.
      </PageHeader>
      <Section title="Share the calendar">
        <div className="search-panel">
          <p className="lead">Help families stay connected by sharing the school calendar page.</p>
          <SocialShare title="Zion Classical Academy Calendar" path="/calendar" label="Share this page" />
        </div>
      </Section>
      <Section title="School calendar">
        <div className="list-stack">
          {loading ? <p className="lead">Loading events...</p> : null}
          {!loading && error ? <p className="notice-light">{error}</p> : null}
          {!loading && !error && events.length === 0 ? <p className="lead">No upcoming events are available right now.</p> : null}
          {events.map((event) => (
            <article className="event-row" key={event.id}>
              <time dateTime={event.startIso || event.date}>{calendarDateLabel(event)}</time>
              <div>
                <h3>{event.title}</h3>
                <p>{event.time} · {event.location}</p>
                {event.description ? <p>{event.description}</p> : null}
                {event.link ? <a className="text-link" href={event.link}>Event details</a> : null}
                <SocialShare title={event.title} path="/calendar" />
              </div>
            </article>
          ))}
        </div>
      </Section>
    </>
  );
}
